const Order = [
  {
    title: 'Order Online',
    description:
      'Tata cara pembelian porogram toko, software toko,aplikasi toko dan mesin kasir barcode toko minimarket.',
    content: `Pilih layanan program software aplikasi restoran cafe rumah makan sesuai dengan kebutuhan mu, selanjutnya lakukan transfer ke rekening kami sesuai harga dan layanan via payment berikut ini.`,
    img: `https://programrestoran.axcora.com/img/qrcode.svg`,
    bank: `BCA BANK`,
    norek: `No Rek 0181884109`,
    account: `Suci Chanifah`,
    confirm:
      'Setelah melakukan transfer silahkan hubungi staff kami , dan lampirkan screenshoot bukti pembayaran agar pesanan order segera di proses.',
    link: 'https://wa.me/62895339403223?text=%20hello%20admin%20saya%20mau%20confirmasi%20order%20chrompos%20program%20toko%20%0A%20Nama%20toko%20:%20%0A%20Alamat%20Resto:%20%0A%20Phone%20:%20%0A%20pembayaran%20via%20transfer%20bank%20%0A%20bca%20bank%200181884109%20%0A%20Online%20Payment%20%0A%20%20Mohon%20diproses%20pesanan%20saya.%0A%20%20Terima%20Kasih',
    pricing: 'List Daftar Harga Program Toko',
    desktop: 'Desktop Offline Version',
    webapp: 'Online Version Web App',
    server: 'Server Edition',
    servertext:
      'Desktop Minimarket Toko Software + Bantuan Installasi + Training + Settup + Support',
    serverprice: 'Rp.1.000.000/Devices',
    serverlink: 'https://app.midtrans.com/payment-links/Chrom-Desktop',
    client: 'Client Edition',
    clienttext:
      'Client Software Program untuk tambahan divisi server (wajib memiliki server version dahulu)',
    clientprice: 'Rp.500.000/Devices',
    clientlink: 'https://app.midtrans.com/payment-links/Chrom-Desktop',
    std: 'Standard',
    stdtext:
      'Wajib memiliki server version + cloud upgrade database untuk integrasi web app admin agar memudahkan owner cek laporan detail via smartphone + website cms.',
    stdprice: 'Rp.1.564.800/Tahun',
    stdlink: 'https://app.midtrans.com/payment-links/Chrom-Cloud',
    pro: 'Premium',
    protext:
      'Wajib memiliki server version + cloud upgrade database untuk integrasi web app admin agar memudahkan owner cek laporan detail via smartphone + website cms + android app informasi + whatsapp online order integrasi program toko.',
    proprice: 'Rp.3.246.800/Tahun',
    prolink: 'https://app.midtrans.com/payment-links/Chrom-Premium',
  },
];

export default Order;
